import { useEffect, useState, useRef } from 'react';
import { getFormattedTime } from '@zorba-shared/core/Services/textService';
import { AiOutlineDownload } from '@react-icons/all-files/ai/AiOutlineDownload';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Radio, Form } from 'antd';
import { BiFilterAlt } from '@react-icons/all-files/bi/BiFilterAlt';
import OffersTable from './Components/OffersTable';
import OfferStats from './Components/OfferStats';
import { BUTTON_VARIANT_LIGHT } from '../../components/forms/ZorbaButton/constants';
import { ZorbaButton } from '../../components/forms';
import {
  exportOffers,
  getCountiesAndMarkets,
  resetAppliedFilters,
  setAppliedFilters,
} from '../../reducers/Offer/actions';
import { ContactSpecialistModal } from '../layout/Components/ContactSpecialistModal';
import { OFFER_FILTERS_DRAWER } from '../../reducers/Drawer/types';
import { setDrawerState } from '../../reducers/Drawer/actions';
import { isMobile } from '../../services/clientService';
import OfferModal from './Components/OfferModal';
import { reportEvent } from '../../services/analyticsService';
import FiltersDrawer from './Components/FiltersDrawer';
import { PREDEFINED_VIEWS } from './constants';
import { AddressFilter } from './Components/AddressFilter';

import './index.scss';

export default (props) => {
  const { isOfferDownloading, appliedFilters } = useSelector(
    ({ OfferReducer }) => OfferReducer,
  );
  const dispatch = useDispatch();
  const [predefinedView, setPredefinedView] = useState(
    PREDEFINED_VIEWS.PENDING_ACTION,
  );
  const [form] = Form.useForm();

  useEffect(() => {
    if (predefinedView === PREDEFINED_VIEWS.PENDING_ACTION) {
      form.resetFields();
      dispatch(resetAppliedFilters());
      dispatch(
        setAppliedFilters('status', {
          isAnyOf: ['offer_request', 'seller_update_asking_price'],
        }),
      );
    }
    if (predefinedView === PREDEFINED_VIEWS.ALL_DEALS) {
      dispatch(resetAppliedFilters(false));
    }
  }, [predefinedView]);

  const downloadOffers = () => {
    reportEvent('dashboard', 'download_csv_start');
    const filename = `Zorba-Offers-${getFormattedTime(
      new Date(),
      'YYYY-MM-DD [at] h.mm.ss A',
    )}.csv`;
    dispatch(exportOffers(filename, { appliedFilters }));
  };

  useEffect(() => {
    dispatch(getCountiesAndMarkets());
  }, []);

  const openFiltersDrawer = () => {
    dispatch(setDrawerState(OFFER_FILTERS_DRAWER, true));
  };

  const searchContainerRef = useRef(null);
  const scrollToTheButtonsContainer = () => {
    if (searchContainerRef.current) {
      searchContainerRef.current.scrollIntoView();
    }
  };

  const { query, ...filtersToApply } = appliedFilters;

  return (
    <div className="offers-page">
      <div className="offer-view-container">
        <div className="offer-view-left">
          <div className="filter-container" ref={searchContainerRef}>
            <AddressFilter setPredefinedView={setPredefinedView} form={form} />
          </div>
          <Radio.Group
            size="large"
            value={predefinedView}
            onChange={(e) => setPredefinedView(e.target.value)}
            className="radio-group"
          >
            <Radio.Button value="pending_action">Pending action</Radio.Button>
            <Radio.Button value="all_deals">All deals</Radio.Button>
          </Radio.Group>
          <ZorbaButton
            variant={BUTTON_VARIANT_LIGHT}
            onClick={openFiltersDrawer}
            fullWidth={isMobile()}
            icon={<BiFilterAlt />}
          >
            {Object.keys(filtersToApply).length
              ? `Applied filters (${Object.keys(filtersToApply).length})`
              : 'Filters'}
          </ZorbaButton>
        </div>
        <ZorbaButton
          variant={BUTTON_VARIANT_LIGHT}
          onClick={downloadOffers}
          icon={<AiOutlineDownload />}
          loading={isOfferDownloading}
          fullWidth={isMobile()}
        >
          Download CSV
        </ZorbaButton>
      </div>
      <div className="offers-page__header">
        <OfferStats />
      </div>
      <Card>
        <OffersTable
          {...props}
          scrollToTheButtonsContainer={scrollToTheButtonsContainer}
        />
      </Card>
      <OfferModal />
      <ContactSpecialistModal />
      <FiltersDrawer setPredefinedView={setPredefinedView} />
    </div>
  );
};
